/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function SortSiteSectionRequestSiteSectionsInnerFromJSON(json) {
    return SortSiteSectionRequestSiteSectionsInnerFromJSONTyped(json, false);
}
export function SortSiteSectionRequestSiteSectionsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: !exists(json, 'id') ? undefined : json['id'],
        sort: !exists(json, 'sort') ? undefined : json['sort']
    };
}
export function SortSiteSectionRequestSiteSectionsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        sort: value.sort
    };
}
